import React, { Component } from 'react';
import { graphql } from 'react-relay';

import CheckoutPage from './CheckoutPage';
import QueryHandler from '../components/misc/QueryHandler';
import { UserConsumer } from '../components/context/UserContext';

class CheckoutPageQueryRenderer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <UserConsumer>
        {({ isLoggedIn }) => (
          <QueryHandler
            query={graphql`
              query CheckoutPageQueryRendererQuery($isLoggedIn: Boolean) {
                viewer {
                  ...CheckoutPage_viewer
                }
              }
            `}
            variables={{
              isLoggedIn: isLoggedIn,
            }}
            render={props => {
              return <CheckoutPage isLoggedIn={isLoggedIn} viewer={props.viewer} />;
            }}
          />
        )}
      </UserConsumer>
    );
  }
}

export default CheckoutPageQueryRenderer;
